// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODFIED DATA : 07-12-2025
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	getPortfolioReportDetailsFailure,
	getPortfolioReportDetailsResponseChanged,
	getPortfolioReportDetailsSuccess,
} from './portfolio-report.action';
import PortFolioReportTypes from './portfolio-report.type';
import { PortfolioReportDetailsGet } from './portfolio-report.service';

/** ***************GET PORTFOLIO REPORT START ************* */
export function* getPortfolioReport({ payload }: any) {
	try {
		const {
			CompanyID,
			BranchID,
			CenterID,
			UserID,
			UserLevel,
			DatabaseName,
			FromDate,
			ToDate,
			TillDate,
			SearchDateType,
			UserRole,
		} = payload;
		const key = 'GetPortfolioReportKey';
		const jsonData = {
			CompanyID: CompanyID,
			BranchID: BranchID,
			CenterID: CenterID,
			UserID: UserID,
			UserLevel: UserLevel,
			UserRole: UserRole,
			DatabaseName: DatabaseName,
			FromDate: FromDate,
			ToDate: ToDate,
			TillDate: TillDate,
			SearchDateType: SearchDateType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(PortfolioReportDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getPortfolioReportDetailsFailure(responseData.data));
		} else {
			yield put(getPortfolioReportDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getPortfolioReportDetailsFailure(error));
	}
}

export function* resetGetPortfolioReportListResponse() {
	yield put(getPortfolioReportDetailsResponseChanged());
}

export function* onGetPortfolioReportListDetails() {
	yield takeLatest(PortFolioReportTypes.PORTFOLIO_REPORT_START, getPortfolioReport);
}

export function* onGetPortfolioReportListResponseReset() {
	yield takeLatest(
		PortFolioReportTypes.PORTFOLIO_REPORT_RESPONSE_RESET,
		resetGetPortfolioReportListResponse,
	);
}
/** ***************GET PORTFOLIO REPORT END ************* */

export function* portfolioAtRiskReportSaga() {
	yield all([call(onGetPortfolioReportListDetails), call(onGetPortfolioReportListResponseReset)]);
}
